<template>
  <div class="wrapper">
    <slot />
  </div>
</template>

<script lang="ts">
export default {
  name: 'Wrapper',
};
</script>

<style lang="stylus" scoped>
@import "~/src/assets/stylus/main.styl";

.wrapper
  max-width $breakpoints.large // 1360px
  padding 0 40px
  margin 0 auto

  +$middle()
    max-width 664px
    padding 0 32px

  +$narrow()
    max-width 100%
    padding 0 25px
</style>
